import React from "react";
import { motion } from "framer-motion";

/**
 * Slow editorial marquee — infinite, GPU-friendly.
 * Duplicates content twice for seamless loop.
 */
export const Marquee = ({
  items = ["IT'S MALIE", "SOUND THAT MOVES CULTURE", "FAITH. FREEDOM. LEGACY.", "IT'S MALIE"],
  speed = 60, // seconds for one full cycle — higher = slower
  className = "",
  variant = "default", // 'default' | 'outline'
}) => {
  const line = items.join("  \u2022  ") + "  \u2022  ";

  return (
    <div
      data-testid="editorial-marquee"
      className={`relative overflow-hidden border-y border-white/8 py-6 sm:py-8 ${className}`}
    >
      <motion.div
        className="flex whitespace-nowrap"
        animate={{ x: ["0%", "-50%"] }}
        transition={{
          duration: speed,
          ease: "linear",
          repeat: Infinity,
        }}
      >
        {[0, 1].map((k) => (
          <span
            key={k}
            className={`font-condensed text-6xl sm:text-8xl lg:text-[10rem] leading-none pr-10 flex items-center gap-10 ${
              variant === "outline"
                ? "text-transparent [-webkit-text-stroke:1px_rgba(212,175,55,0.6)]"
                : "text-white/85"
            }`}
            aria-hidden={k === 1}
          >
            {line.split(" \u2022 ").map((t, i) => (
              <React.Fragment key={i}>
                <span>{t}</span>
                <span className="gold-text text-4xl sm:text-5xl">✦</span>
              </React.Fragment>
            ))}
          </span>
        ))}
      </motion.div>
    </div>
  );
};
